import { InjectionToken, Signal, Type } from '@angular/core';
import type { Map as MaplibreMap } from 'maplibre-gl';

/**
 * Bâtiment 3D du site sur la carte de rejeu des positions (ADR-017). domain-trackers ne peut pas
 * importer domain-sites (qui l'importe) : l'application fournit l'implémentation, inside seulement.
 */
export interface ReplaySiteBuilding {
  /** Le site a un modèle 3D : la carte propose Contours | Modèle 3D. */
  readonly available: Signal<boolean>;
  /** Modèle 3D affiché : le plan en contours est masqué. */
  readonly active: Signal<boolean>;
  /** Décalage écran d'un marqueur pour le montrer à son altitude ; `null` au sol. */
  offset(
    lat: number | null | undefined,
    lon: number | null | undefined,
    alt: number | null | undefined
  ): [number, number] | null;
  /**
   * Charge le modèle du site ; un site sans modèle garde ses contours.
   *
   * @param overlays couches dessinées par-dessus le bâtiment (trajet, points)
   */
  load(map: MaplibreMap, siteId: string, overlays: readonly string[]): Promise<void>;
  detach(): void;
}

export interface ReplaySiteBuildingFeature {
  create(): ReplaySiteBuilding;
  /** Contrôles Plan / étages / 2D-3D ; entrée `building` : l'objet rendu par {@link create}. */
  readonly controls: Type<unknown>;
}

export const REPLAY_SITE_BUILDING = new InjectionToken<ReplaySiteBuildingFeature>('REPLAY_SITE_BUILDING');
